import { render, staticRenderFns } from "./NewsCommentsVisor.vue?vue&type=template&id=e4bb7fea"
import script from "./NewsCommentsVisor.vue?vue&type=script&lang=js"
export * from "./NewsCommentsVisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports